import React from "react";
import { Link, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import Cotización from "../components/Cotización";
import ButtonWhatsapp from "../components/ButtonWhatsapp";
import NavbarLogo from "../components/NavbarLogo";
export default function SolicitarCotización() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const [showSpinner, setShowSpinner] = React.useState(true);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setShowSpinner(false);
    }, 1);

    return () => clearTimeout(timeout); // Limpieza del timeout
  }, []);
  return (
    <div>
      {showSpinner && (
        <div
          id="spinner"
          class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
        >
          {/* Aquí puedes personalizar el spinner */}
          <div class="spinner"></div>
        </div>
      )}

      <div className="container-fluid bg-primary px-5 d-none d-lg-block">
        <div className="row gx-0">
          <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
            <div
              className="d-inline-flex align-items-center"
              style={{ height: "45px" }}
            >
              <a
          href="https://wa.me/+541161361408?text=¡Hola!%20Quisiera%20más%20información%20sobre%20tus%20servicios%20de%20desarrollo%20web%20y%20aplicaciones."
                className="text-light"
                target="_blank"
                rel="noopener noreferrer"
              >
                <small className="me-3 text-light">
                  <i
                    className="bi bi-whatsapp me-2"
                    style={{ color: "white" }}
                  ></i>
                  +54 11 6136 1408
                </small>
              </a>
              <a
                href="tel:+541161361408"
                className="text-light"
                target="_blank"
                rel="noopener noreferrer"
              >
                <small className="me-3 text-light">
                  <i className="fa fa-phone-alt me-2"></i>+54 11 6136 1408
                </small>
              </a>
              <a
                href="mailto:info@elaritech.com"
                className="text-light"
                target="_blank"
                rel="noopener noreferrer"
              >
                <small className="text-light">
                  <i className="fa fa-envelope-open me-2"></i>info@elaritech.com
                </small>
              </a>
            </div>
          </div>
          <div className="col-lg-4 text-center text-lg-end">
            <div
              className="d-inline-flex align-items-center"
              style={{ height: "45px" }}
            >
              {/*    <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href=""><i className="fab fa-twitter fw-normal"></i></a> */}
              <a
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
                href="https://www.facebook.com/profile.php?id=61572272330417"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f fw-normal"></i>
              </a>
              {/*                     <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href=""><i className="fab fa-linkedin-in fw-normal"></i></a>
                    <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href=""><i className="fab fa-instagram fw-normal"></i></a>
                    <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle" href=""><i className="fab fa-youtube fw-normal"></i></a> */}
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid position-relative p-0">
        <nav className="navbar navbar-expand-lg navbar-dark px-5 py-3 py-lg-0">
          <NavbarLogo />
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
          >
            <span className="fa fa-bars"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto py-0">
              <Link to="/" className="nav-item nav-link ">
                Inicio
              </Link>
              <Link to="/sobre-nosotros" className="nav-item nav-link">
                Sobre Nosotros
              </Link>
              <Link to="/nuestros-servicios" className="nav-item nav-link">
                Servicios
              </Link>

              <Link to="/contáctanos" className="nav-item nav-link ">
                Contáctanos
              </Link>
            </div>
            <Link to="/cotización" class="btn btn-primary py-2 px-4 ms-3">
              Solicitar Cotización
            </Link>
          </div>
        </nav>

        <div
          class="container-fluid bg-primary py-5 bg-contact"
          style={{ marginBottom: "90px" }}
        >
          <div class="row py-5">
            <div class="col-12 pt-lg-5 mt-lg-5 text-center">
              <h1 class="display-4 text-white animated zoomIn">
                Solicitar Cotización
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "-10em" }}>
        <Cotización />
      </div>

      <Footer />
      <ButtonWhatsapp />
    </div>
  );
}
